import React from "react";
import changeItemStatus from "../api/changeItemStatus";

const DeleteForm = ({ item, setDeleteForm, setAlert }) => {
  // handle delete Item
  const handleDeleteItem = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    // Change status into 2 for deleting item
    const statusChanged = await changeItemStatus({
      itemId: item.id,
      itemStatus: "2",
    });
    if (statusChanged) {
      setAlert("delete");
    } else {
      setAlert("error");
    }
    // for remove alert
    setTimeout(() => setAlert("null"), 5000);
    setDeleteForm((prev) => !prev);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <p>هل أنت متأكد من أنك تريد حذف هذا المنتج؟</p>
        <button
          onClick={handleDeleteItem}
          className=" my-2 w-32 px-3 py-2 text-sm font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300"
        >
          نعم
        </button>
        <span></span>
        <button
          onClick={() => setDeleteForm((prev) => !prev)}
          className=" my-2 w-32 px-3 py-2 text-sm font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300"
        >
          لا
        </button>
      </div>
    </div>
  );
};

export default DeleteForm;
